<template>
  <div class="content flex">
    <div class="edit">
      <el-form :model="edit"
               :rules="rules"
               ref="ruleForm"
               class="tb-form"
               label-width="140px"
               label-position="right">
        <el-form-item label="优惠券名称："
                      prop="coupon_name">
          <el-input v-model="edit.coupon_name"
                    placeholder="请输入优惠券名字"></el-input>
          <span class="tips">优惠券名称示例；满XX减XX元</span>
        </el-form-item>
        <el-form-item label="起止时间："
                      prop="date">
          <el-date-picker v-model="edit.date"
                          type="datetimerange"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          format="yyyy-MM-dd HH:mm:ss"
                          :clearable="false"
                          range-separator="至"
                          start-placeholder="开始时间"
                          end-placeholder="结束时间" />
        </el-form-item>
        <!-- <el-form-item label="优惠券金额：">
                  <el-input v-model="edit.price"></el-input>
                </el-form-item> -->
        <el-form-item label="满："
                      prop="up_amount">
          <div class="flex">
            <el-input v-model="edit.up_amount"
                      style="width: 224px;"
                      placeholder="请输入(元)"></el-input>
            <span style="color: rgba(0, 0, 0, 0.85); padding-left: 16px;">可用</span>
          </div>
        </el-form-item>
        <el-form-item label="减："
                      prop="cutoff_amount">
          <el-input v-model="edit.cutoff_amount"
                    style="width: 224px;"
                    placeholder="请输入(元)"></el-input>
        </el-form-item>
        <el-form-item label="有效期类型："
                      prop="effective_type">
          <el-radio-group v-model="edit.effective_type">
            <el-radio :label="1">按天数</el-radio>
            <el-radio :label="2">按时间</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="有效期："
                      v-show="2 === edit.effective_type">
          <el-date-picker v-model="edit.effective_date"
                          type="datetimerange"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          format="yyyy-MM-dd HH:mm:ss"
                          :clearable="false"
                          range-separator="至"
                          start-placeholder="开始时间"
                          end-placeholder="结束时间" />
        </el-form-item>
        <el-form-item label="有效期："
                      prop="effective_day"
                      v-show="1 === edit.effective_type">
          <div class="flex">
            <el-input v-model="edit.effective_day"
                      placeholder="请输入天数"></el-input>
            <span style="color: rgba(0, 0, 0, 0.85); padding-left: 16px;">天</span>
          </div>
        </el-form-item>
        <el-form-item label="数量："
                      prop="stock">
          <div class="flex">
            <el-input v-model="edit.stock"
                      placeholder="请输入数量"></el-input>
            <span style="color: rgba(0, 0, 0, 0.85); padding-left: 16px;">张</span>
          </div>
        </el-form-item>
        <el-form-item label="优惠券规则："
                      prop="rules">
          <el-input v-model="edit.rules"
                    type="textarea"
                    placeholder="请输入优惠券规则"></el-input>
          <div class="tips">查看优惠券<span class="demo-text"
                  @click="toDemo">规则示例</span></div>
        </el-form-item>
        <el-form-item label="是否与Vip会员卡共享："
                      class="specail-form-item">
          <el-radio-group v-model="edit.enable_vip">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="生效状态：">
          <el-radio-group v-model="edit.status">
            <el-radio :label="1">生效中</el-radio>
            <el-radio :label="0">未生效</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-divider direction="horizontal"></el-divider>
        <div>
          <div>
            <span style="font-size: 14px;color: rgba(0,0,0,0.85);font-weight: 600; margin-bottom: 8px; display: block;">指定商品使用（选填）：</span>
          </div>
          <span style="display: block; margin-bottom: 24px;">提示：优惠券可以指定商品使用，指定商品券只能对该商品进行使用</span>
          <el-button type="primary"
                     icon="el-icon-plus"
                     style="margin-bottom: 16px;"
                     @click="chooseProduct">关联商品</el-button>
          <el-table class="tb-table"
                    :data="selectProduct">
            <el-table-column label="关联商品名称"
                             prop="product_name"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span @click="onDelProduct(scope.row.prouct_id)">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-form-item style="margin-top: 32px;">
          <el-button type="primary"
                     @click="onConfirm">确定</el-button>
          <el-button @click="onCancel">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="demo">
      <h3 class="title">优惠券示例</h3>
      <img src="https://image.topboom0912.com/admin_static_img/demo/coupon.png"
           alt="demo"
           width="298px">
    </div>
    <el-dialog title="选择商品"
               width="50vw"
               :visible.sync="productDialog">
      <div class="product-search flex">
        <span>搜索商品：</span>
        <el-input v-model="productname"
                  style="width: 216px;"
                  @change="serchGoods"></el-input>
      </div>
      <el-table ref="multipleTable"
                :data="productData"
                class="tb-table"
                height="48vh"
                highlight-current-row
                @current-change="handleCurrentChange">
        <el-table-column type="index"
                         width="80" />
        <el-table-column prop="product_id"
                         label="商品id"
                         width="100" />
        <el-table-column prop="product_name"
                         label="商品名称" />
      </el-table>
      <el-pagination background
                     class="tb-pagination"
                     layout="prev, pager, next"
                     :current-page="page.no + 1"
                     :page-size="page.size"
                     :total="page.total"
                     @current-change="pageChange" />
      <span slot="footer">
        <el-button @click="productDialog = false">取 消</el-button>
        <el-button type="primary"
                   @click="onConfirmProduct">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CouponAdd',
  data () {
    return {
      productname: '',
      productDialog: false,
      id: null,
      edit: {
        effective_type: 1,
        expire_time: '',
        effective_time: '',
        effective_date: '',
        coupon_name: '',
        coupon_type: 1,
        up_amount: '',
        cutoff_amount: '',
        effective_day: '',
        stock: '',
        rules: '',
        enable_vip: 0,
        status: 1,
        date: null,
        product_name: '',
        external_id: ''
      },
      rules: {
        coupon_name: [{ required: true, message: '请输入名称' }],
        up_amount: [{ required: true, message: '请输入金额' }],
        cutoff_amount: [{ required: true, message: '请输入金额' }],
        // effective_day: [{required: true, message: '请输入天数'}],
        stock: [{ required: true, message: '请输入数量' }],
        rules: [{ required: true, message: '请输入规则' }],
        date: [{ required: true, message: '请输入选择时间' }],
        effective_type: [{ required: true, message: '请选择有效期类型' }]
      },
      categroyOptions: [],
      statusOptions: [],
      page: {
        no: 0,
        size: 10,
        total: 0
      },
      productData: []
    }
  },
  mounted () {
    this.id = this.$route.query.id * 1 || null
    if (this.id) {
      this.getDetail()
    }
  },
  computed: {
    selectProduct () {
      if (this.edit.external_id * 1 > 0) {
        return [{ product_id: this.edit.external_id, product_name: this.edit.product_name }]
      } else {
        return []
      }
    }
  },
  methods: {
    async getDetail () {
      const params = {
        id: this.id
      }
      const url = 'admin/coupon/detail'
      this.$https.get(url, { params }).then(res => {
        if (!res) return
        this.edit.effective_type = res.effectiveType
        this.edit.effective_date = [this.$dayjs(res.effectiveTime).format('YYYY-MM-DD HH:mm:ss'), this.$dayjs(res.expireTime).format('YYYY-MM-DD HH:mm:ss')]
        this.edit.coupon_name = res.couponName
        this.edit.coupon_type = res.couponType
        this.edit.up_amount = this.$np.divide(res.upAmount, 100)
        this.edit.cutoff_amount = this.$np.divide(res.cutoffAmount, 100)
        this.edit.effective_day = res.effectiveDay
        this.edit.stock = res.stock
        this.edit.rules = res.rules
        this.edit.enable_vip = res.enableVip
        this.edit.status = res.status
        this.edit.product_name = res.productName
        this.edit.external_id = res.externalId;
        this.edit.date = [this.$dayjs(res.startTime).format('YYYY-MM-DD HH:mm:ss'), this.$dayjs(res.endTime).format('YYYY-MM-DD HH:mm:ss')]
      })
    },

    onDelProduct () {
      this.$confirm('您确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.edit.external_id = ''
        this.edit.product_name = ''
      })
    },

    chooseProduct () {
      this.productname = ''
      this.page.no = 0
      this.productDialog = true
      this.getProduct()
    },
    serchGoods () {
      this.page.no = 0
      this.getProduct()
    },
    onConfirmProduct () {
      if (this.productChoose.length === 0) {
        this.$message.error("请选择商品")
      } else {
        this.productDialog = false
        const product = this.productChoose[0]
        this.edit.external_id = product.product_id
        this.edit.product_name = product.product_name
      }
    },
    handleCurrentChange (val) {
      this.productChoose = [val]
    },
    pageChange (no) {
      this.page.no = no - 1
      this.getProduct()
    },
    getProduct () {
      const { no, size } = this.page
      const params = {
        page_no: no,
        page_size: size,
        name: this.productname
      }
      const url = 'admin/theme/product/add/list'
      this.$https.get(url, { params }).then(res => {
        if (!res) return
        this.page.total = res.total_count
        this.productData = res.list
      })
    },
    async onConfirm () {
      const rule = await new Promise(resolve => {
        this.$refs.ruleForm.validate((valid) => {
          resolve(valid)
        })
      })
      if (!rule) return
      const { effective_type, coupon_name, effective_day, stock, rules, enable_vip, status, date, effective_date, external_id } = this.edit
      const params = {
        effective_type,
        coupon_name,
        coupon_type: external_id * 1 > 0 ? 2 : 1,
        "up_amount": this.$np.times(this.edit.up_amount, 100),
        "cutoff_amount": this.$np.times(this.edit.cutoff_amount, 100),
        effective_day,
        stock,
        rules,
        enable_vip,
        status,
        effective_time: effective_date[0],
        expire_time: effective_date[1],
        start_time: date[0],
        end_time: date[1],
        external_id: external_id
      }
      if (this.id) params.id = this.id
      const url = 'admin/coupon/edit'
      this.$https.post(url, params).then(res => {
        if (res) this.$router.push('/coupon/list')
      })
    },
    onCancel () {
      this.$router.push('/coupon/list')
    },
    toDemo () {
      this.$alert('<img src="https://image.topboom0912.com/admin_static_img/demo/coupon_demo.png" alt="demo" width="410px">', '', {
        dangerouslyUseHTMLString: true,
        customClass: 'tb-demo-dialog'
      })
    }
  }
}
</script>

<style>
.tb-form .specail-form-item .el-form-item__label {
  width: 165px !important;
}
</style>

<style scoped lang="scss">
.edit {
  padding-right: 70px;
  border-right: 1px solid #e8e8e8;
  box-sizing: border-box;

  .tb-form {
    width: 610px;

    .tips {
      padding-top: 8px;
      color: rgba(0, 0, 0, 0.45);
    }

    .demo-text {
      color: #1890ff;
      cursor: pointer;
      font-weight: 600;
    }
  }
}

.demo {
  padding-left: 70px;

  .title {
    margin: 0;
    padding-bottom: 16px;
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }
}
</style>
